import { create } from 'zustand';

export type UseUserIdStore = {
  userId: string;
};

const defaultValue: UseUserIdStore = {
  userId: '',
};

export const useUserIdStore = create<UseUserIdStore>(() => ({
  ...defaultValue,
}));

export const useUserIdFilter = () => useUserIdStore((state) => state.userId);

export const setUserIdFilter = (userId: UseUserIdStore['userId']) => {
  useUserIdStore.setState({ userId });
};
